import React from 'react';

import ProjectContext from './context';

const useProject = () => React.useContext(ProjectContext);

export default useProject;
